import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Amazonservices(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="Consultant">
                            <h2>Azure Consultant - Your Migration & Development Partner</h2>
                        </div>
                      
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Seamless deployment of microservices</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Variable cloud capacities</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Future scalability options</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <p>Azure allows convenient, easy, remote access to data with built-in permission features. We are your Azure consultant to help you deploy Azure for highly-efficient business operations and outputs. Bring your operations and data utilities to the cloud and achieve business-centric cost efficiencies.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Azure is for all business sizes and revenue levels. We can help you select the right hyper-scale solution in Azure cloud practices and determine whether a public, private, or hybrid solution is right for your business process management.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>We help organizations build a sustainable business and open new ways for innovation and scalability in the future. Start with a code review and audit and create an action plan that will compound your Microsoft Azure ROI.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Assess Business Requirements</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Azure allows convenient, easy, remote access to data with built-in permission features. We are your Azure consultant to help you deploy Azure for highly-efficient business operations and outputs. Bring your operations and data utilities to the cloud and achieve business-centric cost efficiencies.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Unlock Advanced IT Operations</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Azure is for all business sizes and revenue levels. We can help you select the right hyper-scale solution in Azure cloud practices and determine whether a public, private, or hybrid solution is right for your business process management.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Evaluate Business Results and Improve</Accordion.Header>
                                    <Accordion.Body>
                                        <p>We help organizations build a sustainable business and open new ways for innovation and scalability in the future. Start with a code review and audit and create an action plan that will compound your Microsoft Azure ROI.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Amazonservices;